import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function HoldEventItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    const handleSelect = (): void => {
        drawerControls.open({
            type: 'hold-event',
            props: { eventId: clickParams.eventId },
        });
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-hold-event"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
